import { getEnvPath, findOutWhichEnv } from '../../utils/env'
import { getHeaders, handleErrors } from './utils'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function getActivatedAccounts() {
  return fetch(`${BASE_PATH}/account`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getChannels() {
  return fetch(`${BASE_PATH}/channel`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getBrokers() {
  return fetch(`${BASE_PATH}/broker`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function deleteAccount(id) {
  return fetch(`${BASE_PATH}/account/${id}`, getHeaders('DELETE')).then((r) => r)
}

function createAccount(payload) {
  return fetch(`${BASE_PATH}/account`, getHeaders('POST', { ...payload })).then((r) => r.json())
}

function getMetadata(id) {
  return fetch(`${BASE_PATH}/broker/${id}/meta`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function editAccount(payload, id) {
  return fetch(`${BASE_PATH}/account/${id}`, getHeaders('PATCH', { ...payload }))
}

function getTemplateOrigins() {
  return fetch(`${BASE_PATH}/ui/template/origins`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getWabaWithCatalog() {
  return fetch(`${BASE_PATH}/waba`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function checkCatalog({ catalogId, wabaId }) {
  return fetch(`${BASE_PATH}/catalog/${catalogId}/check?wabaId=${wabaId}`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function syncCatalog({ wabaId, catalogId }) {
  return fetch(`${BASE_PATH}/catalog/sync`, getHeaders('PUT', { wabaId, catalogId }))
}

function refreshCatalog({ wabaId, catalogId }) {
  return fetch(`${BASE_PATH}/catalog/refresh`, getHeaders('PUT', { wabaId, catalogId }))
    .then((r) => r.json())
    .then(handleErrors)
}

export {
  getActivatedAccounts,
  getChannels,
  getBrokers,
  deleteAccount,
  createAccount,
  getMetadata,
  editAccount,
  getTemplateOrigins,
  getWabaWithCatalog,
  checkCatalog,
  syncCatalog,
  refreshCatalog,
}
